import Commons from '../../../../Services/Common/Common';

/**
 * PLA_BASIC 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *      1. ADMIN: 관리자일 때만 필수
 *
 * - mapper: 저장/삭제 API payload 생성 규칙
 *   - mapRowsBySchema(rows, mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapRowsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다. (U3참고)
 */
export const PLA_BASIC_Schema = {
  fields: {
    no: { initial: '', label: 'No' },
    coCd: {
      initial: '',
      label: '회사명',
      required: 'Y',
      requiredWhen: 'ADMIN',
    },
    coNm: { initial: '', label: '회사명(표시)' },

    custCd: { initial: '', label: '사업장코드' },
    custNm: { initial: '', label: '사업장명', required: 'Y' },

    businessNo: { initial: '', label: '사업자등록번호' },
    custTel: { initial: '', label: '전화번호' },
    custFax: { initial: '', label: '팩스' },

    ceo: { initial: '', label: '사업장 대표자' },
    companyCeoNm: { initial: '', label: '회사대표자' },

    custType: {
      initial: '0',
      label: '업체구분',
    },

    mstCustCd: { initial: '', label: '소속 사업장코드' },
    mstCustNm: { initial: '', label: '소속 사업장명' },

    address1: { initial: '', label: '주소' },
    address2: { initial: '', label: '상세주소' },

    videoLocation: { initial: '', label: '교육 동영상 위치' },
    eduLocation: { initial: '', label: '교육파일 위치' },

    indCd: { initial: '', label: '업종코드' },
    industrialMain: { initial: '', label: '업종 대분류' },
    industrialSub: { initial: '', label: '업종 중분류' },
    industrialSmall: { initial: '', label: '업종 소분류' },

    indLarge: { initial: '', label: '대분류' },
    indMiddle: { initial: '', label: '중분류' },
    indSmall: { initial: '', label: '소분류' },

    businessMaNo: { initial: '', label: '사업장관리번호' },
    businessStartNo: {
      initial: '',
      label: '사업개시번호',
    },

    workNo: { initial: 0, label: '상시근로자수' },
    mstNo: { initial: 0, label: '수급업체수' },

    itemNm: { initial: '', label: '생산품목' },
    location: { initial: '', label: '소재지' },

    contractStatus: { initial: '여', label: '도급여부' },
    original: { initial: '', label: '원도급사명' },

    journeyman: { initial: '', label: '직인' },
    journeymanFileNm: { initial: '', label: '직인 파일명' },
    journeymanFile: { initial: null, label: '직인 파일' },
  },

  mapper: {
    search1: {
      UserId: (_, context) => context.userInfo.userid,
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo.authCd),
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo.coCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
    search2: {
      CustCd: (_, context) => Commons.EncryptAES(context.CustCd || ''),
    },

    search3: {
      CoCd: (_, context) => Commons.EncryptAES(context.CoCd || ''),
    },
    save1: {
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd) || '',
      CustCd: (row) => Commons.EncryptAES(row.custCd) || '',
      CustNm: (row) => Commons.EncryptAES(row.custNm) || '',
      Ceo: (row) => Commons.EncryptAES(row.ceo) || '',
      BusinessNo: (row) => Commons.EncryptAES(row.businessNo) || '',
      BusinessMaNo: (row) => Commons.EncryptAES(row.businessMaNo) || '',
      BusinessStartNo: (row) => Commons.EncryptAES(row.businessStartNo) || '',
      CustTel: (row) => Commons.EncryptAES(row.custTel) || '',
      CustFax: (row) => Commons.EncryptAES(row.custFax) || '',
      IndCd: (row) => Commons.EncryptAES(row.indCd) || '',
      WorkNo: (row) => Commons.EncryptAES(row.workNo) || '',
      Location: (row) => Commons.EncryptAES(row.location) || '',
      CoCd: (row, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? row.coCd
            : context.userInfo?.coCd
        ) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },

    save2: {
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo?.coCd) || '',
      CustCd: (row) => Commons.EncryptAES(row.custCd) || '',
      Journeyman: (row) => Commons.EncryptAES(row.journeyman || ''),
      JourneymanFileNm: (row) => Commons.EncryptAES(row.journeymanFileNm || ''),
    },

    save3: {
      CustCd: (_, context) => Commons.EncryptAES(context.custCd) || '',
      CmId: (row) => Commons.EncryptAES(row.cmId) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
    delete1: {
      CustCd: (row) => Commons.EncryptAES(row.custCd) || '',
    },
  },
};
